<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
    <h4 class="mt-0">Dokument auswählen</h4>
    <div class="mat-elevation-z6">
        <app-ledger-import-select-table
            [ledgerImportFilter]="selectableSrcLedgerImportsFilter"
            [defaultDocumentTypesFilter]="selectableSrcLedgerImportsDocumentTypesDefaultFilter"
            (selectedLedgerImportsChange)="selectedLedgerImportChange($event.length ? $event[0] : undefined)"
        ></app-ledger-import-select-table>
    </div>
    <p>
        <mat-slide-toggle class="font-normal" [formControl]="setAmount">Abschlag selbst wählen</mat-slide-toggle>
        <app-hint-icon class="mx-4" hint="Wenn Sie Den Abschlag nicht selbst wählen, werden die Positionen aus dem ausgewählten Dokument übernommen"></app-hint-icon>
    </p>
    <ng-container *ngIf="setAmount.value">
        <h4 class="mb-0">Abschlag auswählen</h4>
        <div class="sum-inputs">
            <mat-form-field [appearance]="!amountForm.value.usePercent ? 'outline' : undefined">
                <mat-label>Abschlag ({{ currencyCode$ | async }})</mat-label>
                <input type="number" [ngModel]="amountForm.value.decimal" (ngModelChange)="setDecimal($event)" matInput />
                <span matSuffix>{{ currencyCode$ | async }}</span>
            </mat-form-field>
            <mat-form-field [appearance]="amountForm.value.usePercent ? 'outline' : undefined">
                <mat-label>Abschlag (%)</mat-label>
                <input type="number" [ngModel]="amountForm.value.percent" (ngModelChange)="setPercent($event)" matInput />
                <span matSuffix>%</span>
            </mat-form-field>
        </div>
    </ng-container>
    <p>
        <mat-slide-toggle class="font-normal" [formControl]="isKumulativ">Kumulativ</mat-slide-toggle>
        <app-hint-icon class="mx-4" hint="Bei kumulativen Abschlagsrechnungen werden vorangegangene Abschlagsrechnungen und zahlungen in der Rechnung aufgeführt."></app-hint-icon>
    </p>
    <ng-container *ngIf="isKumulativ.value">
        <h4 class="mb-0">Dokumente auswählen</h4>
        <div class="mat-elevation-z6 mb-4">
            <app-ledger-import-select-table
                multiple
                [ledgerImportFilter]="selectablePrevLedgerImportsFilter"
                [defaultDocumentTypesFilter]="selectablePrevLedgerImportsDocumentTypesDefaultFilter"
                [(selectedLedgerImports)]="selectedLedgerImports"
            ></app-ledger-import-select-table>
        </div>
        <!--        <mat-form-field *ngIf="setAmount.value">-->
        <!--            <mat-label>Abschlag ({{ currencyCode$ | async }})</mat-label>-->
        <!--            <input type="number" [ngModel]="amountForm.value.decimal" (ngModelChange)="setDecimal($event)" matInput />-->
        <!--            <span matSuffix>{{ currencyCode$ | async }}</span>-->
        <!--        </mat-form-field>-->
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
    <button type="button" app-button Color="cancel" [mat-dialog-close]="undefined" Inverted>abbrechen</button>
    <button type="button" app-button Color="green" [IsLoading]="ls.IsLoading$ | async" [Disabled]="!(selectedLedgerImportId$ | async)" (click)="submit()">Speichern</button>
</mat-dialog-actions>
